import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['form'];
  static values = { entityName: String };

  confirm(event) {
    event.preventDefault();

    const form = this.formTarget;

    $('#dialog-confirm-archive-data').remove();

    const dialog = $('<div>', { id: 'dialog-confirm-archive-data', title: 'Archive Data' });
    $('<p>').text(`Are you sure you want to archive data for ${this.entityNameValue}?`).appendTo(dialog);
    dialog.appendTo('body');

    $('#dialog-confirm-archive-data').dialog({
      resizable: false,
      draggable: false,
      width: 500,
      modal: true,
      buttons: {
        'Cancel': function() {
          $(this).dialog('close');
        },
        'Archive Data': function() {
          $(this).dialog('close');
          showSpinner();
          form.submit();
        }
      }
    });
  }
}
